export default "__VITE_ASSET__CPgUH9Ke__"